<template>
  <v-container>
    <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }">
      <v-row>
        <v-col md="6">
          <h1 class="font-weight-medium">{{ $t('Eventos DO Cava') }} </h1>
        </v-col>
      </v-row>



      <v-row>
        <v-col md="6">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <v-text-field
                :label="$t('Nombre ES')"
                filled
                v-model="evento.nombre_es"
                maxlength="250"
                :error-messages="errors"
            ></v-text-field>
          </ValidationProvider>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="6">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <v-text-field
                :label="$t('Nombre CA')"
                filled
                v-model="evento.nombre_ca"
                maxlength="250"
                :error-messages="errors"
            ></v-text-field>
          </ValidationProvider>
        </v-col>
      </v-row>

      <!--      <v-row>-->
      <!--        <v-col md="12">-->
      <!--          <ValidationProvider v-slot="{ errors }" rules="required">-->
      <!--            <v-text-field-->
      <!--                :label="$t('Descripción breve del evento (Inglés)')"-->
      <!--                filled-->
      <!--                v-model="evento.descripcion_breve_en"-->
      <!--                maxlength="250"-->
      <!--                :error-messages="errors"-->
      <!--            ></v-text-field>-->
      <!--          </ValidationProvider>-->
      <!--        </v-col>-->
      <!--      </v-row>-->

      <v-row>
        <v-col md="12">
            <v-text-field
                :label="$t('Descripción breve del evento (Español)')"
                filled
                v-model="evento.descripcion_breve_es"
                maxlength="250"
            ></v-text-field>



        </v-col>
      </v-row>

      <v-row>
        <v-col md="12">
            <v-text-field
                :label="$t('Descripción breve del evento (Catalán)')"
                filled
                v-model="evento.descripcion_breve_ca"
                maxlength="250"
            ></v-text-field>



        </v-col>
      </v-row>

      <!--      <v-row>-->
      <!--        <v-col md="12">-->
      <!--          <ValidationProvider v-slot="{ errors }" rules="required">-->
      <!--            <v-textarea-->
      <!--                :label="$t('Descripción larga del evento (Inglés)')"-->
      <!--                filled-->
      <!--                v-model="evento.descripcion_en"-->
      <!--                maxlength="250"-->
      <!--                :error-messages="errors"-->
      <!--            ></v-textarea>-->
      <!--          </ValidationProvider>-->
      <!--        </v-col>-->
      <!--      </v-row>-->

      <v-row>
        <v-col md="12">
          <ValidationProvider v-slot="{ errors }" rules="required">


            <label>{{ $t('Descripción larga del evento (Español)') }}</label>
            <tiptap-vuetify
                v-model="evento.descripcion_es"
                :extensions="extensions"
            />
            <span style="color: #a95657;font-size: 14px">{{ errors[0] }}</span>


          </ValidationProvider>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="12">
          <ValidationProvider v-slot="{ errors }" rules="required">


            <label>{{ $t('Descripción larga del evento (Catalán)') }}</label>
            <tiptap-vuetify
                v-model="evento.descripcion_ca"
                :extensions="extensions"
            />
            <span style="color: #a95657;font-size: 14px">{{ errors[0] }}</span>


          </ValidationProvider>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="6">
            <v-text-field
                :label="$t('Sitio web')"
                filled
                v-model="evento.web"
                maxlength="250"
            ></v-text-field>
        </v-col>

        <v-col md="6">
          <ValidationProvider v-slot="{ errors }" rules="required|email">
            <v-text-field
                :label="$t('Email de contacto')"
                filled
                v-model="evento.email"
                maxlength="250"
                :error-messages="errors"
            ></v-text-field>
          </ValidationProvider>
        </v-col>
      </v-row>


      <v-row>
        <v-col md="6">
            <v-select
                :label="$t('Región')"
                :items="regions"
                filled
                v-model="evento.region"
                maxlength="250"
            ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="6">
          <calendar-select :mydate="evento.fecha_limite" v-on:calendar-change="evento.fecha_limite = $event"
                           :title="$t('Fecha límite incripción')" :validation="{required:true}"></calendar-select>
        </v-col>
        <v-col md="6">
          <calendar-select :mydate="evento.fecha_limite_envio" v-on:calendar-change="evento.fecha_limite_envio = $event"
                           :title="$t('Fecha límite envío del producto')"
                           ></calendar-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <upload
              :files="isarr(evento.foto)"
              :multiple="false"
              :title="$t('Foto')"
              :validation="{required:true,size:5000,ext:['png','jpg','jpeg']}"
              :hint="$t('Subir foto (jpg o png, max 2 MB)\n')"
              :accept="'.png,.jpg,.jpeg'"
              v-on:file-update="evento.foto = $event"
          ></upload>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <upload
              :files="evento.files"
              :multiple="true"
              :title="$t('Adjuntos')"
              :hint="$t('Subir documento (s)')+' xlsx, pdf, zip, doc o docx'"
              :accept="'.xlsx,.doc,.docx,.zip,.pdf'"
              :validation="{required:false,size:5000,ext:['xlsx','pdf','zip','doc','docx']}"
              v-on:file-update="evento.files = $event"
          ></upload>
        </v-col>
      </v-row>
      <div class="mb-10">
        <div class="pb-1 primary--text">{{ $t('Fechas') }}</div>
        <v-sheet v-for="(item,index) in evento.fechas" color="grey lighten-5 rounded">
          <v-row class="pa-3 pb-0">
            <v-col md="4">
              <calendar-select v-on:calendar-change="item.fecha_limite = $event" :mydate="item.fecha_limite"
                               :title="$t('Fecha')" :validation="{required:true}"></calendar-select>
            </v-col>
            <v-col md="2">
              <v-select
                  v-model="item.hours"
                  :items="hours"
                  :label="$t('Hora')"
              ></v-select>
            </v-col>
            <v-col md="2">
              <v-select
                  v-model="item.minute"
                  :items="mins"
                  :label="$t('Minutos')"
              ></v-select>
            </v-col>
            <v-col md="4" class="text-right" v-if="index > 0">
              <v-btn tile large icon color="red" @click="removeDate(index)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-col>
            <v-col md="12">
              <v-text-field
                  :label="$t('Texto')"
                  filled
                  v-model="item.texto"
                  maxlength="250"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-sheet>
        <v-row>
          <v-col md="12" class="text-center">
            <v-btn color="primary" tile large icon @click="addDate()">
              <v-icon>mdi-plus-circle</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>


      <div class="mb-10">
        <div class="pb-1 primary--text">{{ $t('Direcciones') }}</div>
        <v-sheet v-for="(item, index) in evento.dirreccions" color="grey lighten-5 rounded">
          <v-row class="pa-3 pb-0">
            <v-col md="4">
                <v-text-field
                    :label="$t('Dirreccion')"
                    filled
                    v-model="item.dirreccion"
                    maxlength="250"
                ></v-text-field>
            </v-col>
            <v-col md="2">
                <v-text-field
                    :label="$t('Cuidad')"
                    filled
                    v-model="item.cuidad"
                    maxlength="250"
                ></v-text-field>
            </v-col>
            <v-col md="2">
                <v-text-field
                    :label="$t('Código postal')"
                    filled
                    v-model="item.cp"
                    maxlength="250"
                ></v-text-field>
            </v-col>
            <v-col md="2">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-select
                    :label="$t('Pais')"
                    filled
                    v-model="item.pais"
                    :items="countries"
                    :item-text="'name'"
                    :item-value="'code'"
                    maxlength="250"
                    :error-messages="errors"
                ></v-select>
              </ValidationProvider>
            </v-col>
            <v-col md="2" class="text-right" v-if="index > 0">
              <v-btn tile large icon color="red" @click="removeAddress(index)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-col>
            <v-col md="12">
              <v-text-field
                  :label="$t('Texto')"
                  filled
                  v-model="item.texto"
                  maxlength="250"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-sheet>
        <v-row>
          <v-col md="12" class="text-center">
            <v-btn color="primary" tile large icon @click="addAddress()">
              <v-icon>mdi-plus-circle</v-icon>
            </v-btn>
          </v-col>
        </v-row>

      </div>


      <v-row>
        <v-col md="12">
            <v-textarea
                :label="$t('Dirección de envio')"
                filled
                v-model="evento.direccion_envio"
            ></v-textarea>
        </v-col>
      </v-row>


      <div class="mb-10">
        <div class="pb-1 primary--text">
          {{ $t('¿A quién enviar este evento? (Si no seleccionas nada, son todas las bodegas)') }}
        </div>
        <v-sheet color="grey lighten-5 rounded">

          <v-row class="pa-3 pb-0">
            <v-col md="6">
              <v-select
                  :label="$t('Mercados de exportación')"
                  filled
                  v-model="evento.permiso.mercados"
                  :items="mercados"
                  maxlength="250"
                  multiple
                  item-value="id"
                  item-text="name"
                  :disabled="evento.state!=0"
              ></v-select>
            </v-col>
            <v-col md="6">
              <v-select
                  :label="$t('Categorías de Cava')"
                  filled
                  v-model="evento.permiso.cavas"
                  :items="cava"
                  maxlength="250"
                  multiple
                  item-value="id"
                  item-text="name"
                  :disabled="evento.state!=0"
              ></v-select>
            </v-col>
            <v-col md="6">
              <v-select
                  :label="$t('Producción')"
                  filled
                  v-model="evento.permiso.produccion"
                  :items="produccion"
                  maxlength="250"
                  multiple
                  item-value="id"
                  item-text="name"
                  :disabled="evento.state!=0"
              ></v-select>
            </v-col>
            <v-col md="6">
              <v-checkbox v-model="evento.permiso.enoturismo" :label="$t('Enoturism')" :disabled="mode=='put'"></v-checkbox>

            </v-col>
          </v-row>
        </v-sheet>
      </div>

      <v-row>
        <v-col md="4">
          <v-select
              :label="$t('Límite de cavas')"
              filled
              v-model="evento.limite_cavas"
              :items="[0,1,2,3,4,5,6]"
              maxlength="250"
          ></v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="4">
          <v-checkbox v-model="evento.asistir" :label="$t('Asistir al evento con un ticket')"></v-checkbox>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="4">
          <v-select
              :label="$t('Estado')"
              filled
              v-model="evento.state"
              :items="currentState"
              :item-text="'name'"
              :item-value="'value'"
              maxlength="250"
          ></v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="6">
          <v-btn :disabled="disabled" @click="submit()" large color="primary" class="white--text">
            {{ $t('Guardar') }}
          </v-btn>
        </v-col>
        <v-col md="6" style="text-align: right">
          <v-btn @click="confirmit=true" v-if="!confirmit" large color="red" class="white--text">
            {{ $t('Borrar') }}
          </v-btn>
          <v-btn v-if="confirmit" @click="del()" large color="red" class="white--text">
            {{ $t('¿Estás seguro?') }}
          </v-btn>
        </v-col>
      </v-row>
    </ValidationObserver>

  </v-container>
</template>


<script>
import axios from "axios"
import {ValidationProvider, ValidationObserver, setInteractionMode} from 'vee-validate';
import UploadService from "../services/SimpleUploadService";
import CalendarSelect from "@/components/CalendarSelect";
import Upload from "@/components/Upload";
import JSON5 from "json5"
import countries from "@/plugins/countries"
import { TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, Paragraph, BulletList, OrderedList, ListItem, Link, Blockquote, HardBreak, HorizontalRule, History } from 'tiptap-vuetify'


setInteractionMode('eager')

export default {
  components: {
    Upload, ValidationProvider, ValidationObserver, CalendarSelect,TiptapVuetify
  },
  data() {
    return {
      extensions: [
      Link,
      Strike,
      Italic,
      Bold,
      ListItem,
      BulletList,
      OrderedList,
      [Heading, {
        options: {
          levels: [2]
        }
      }],
    ],
      editor:null,
      id: "",
      confirmit: false,
      countries: countries,
      mode: "post",
      disabled:false,
      regions: [
        "España",
        "usa",
        "japan",
        "belgum",
        "uk",
        "germany",
        "france",
        "holand",
        "sweeden",
        "others",
      ],
      progress: 0,
      checkbox1: false,
      currentState:[],
      states: {
        //Cancelled
        "-1": [
          {name: "Cancelado", value: -1, state: 0},
          {name: "Publicado", value: 1, state: 1},
        ],
        //Draft
        "0": [
          {name: "Borrador", value: 0, state: 0},
          {name: "Publicado", value: 1, state: 1},
        ],
        //Published
        "1": [
          {name: "Cancelado", value: -1, state: 1},
          {name: "Publicado", value: 1, state: 0},
          {name: "Enviar", value: 2, state: 1},
        ],
        //Sent
        "2": [
          {name: "Cancelado", value: -1, state: 0},
          {name: "Enviar", value: 2, state: 1},
        ]
      },
      fecha: {
        "fecha_limite": null,
        "texto": "",
        "hours": "09",
        "minute": "00"
      },
      datetemplate: {
        "fecha_limite": null,
        "texto": "",
        "hours": "00",
        "minute": "00"
      },
      address: {
        cuidad: "",
        dirreccio: "",
        cp: "",
        pais: "",
        texto: ""
      },
      evento: {
        "nombre": "",
        "nombre_es": "",
        "nombre_ca": "",
        "descripcion_breve_en": "",
        "descripcion_breve_es": "",
        "descripcion_breve_ca": "",
        "descripcion_en": "",
        "descripcion_ca": "",
        "descripcion_es": "",
        "web": "",
        "email": "",
        "region": "",
        "fecha_limite": "",
        "direccion_envio": "",
        "fecha_limite_envio": null,
        "foto": [],
        files: [
          {
            "nombre": null,
            "file_name": null,
            "mime": "",
            "size": "",
            "created": null,
            "modified": null
          }
        ],
        fechas: [
          {
            "fecha_limite": null,
            "texto": "",
            "hours": "00",
            "minute": "00"
          }
        ],
        dirreccions: [
          {
            "cuidad": "",
            "dirreccion": "",
            "cp": "",
            "pais": "",
            "texto": ""
          }
        ],
        limite_cavas: 1,
        asistir: false,
        permiso: {
          mercados: [],
          cavas: [],
          produccion: [],
          enoturismo: false,

        }
      },
      mercados: [
        {id: "usa", name: "usa"},
        {id: "japan", name: "japan"},
        {id: "belgum", name: "belgum"},
        {id: "uk", name: "uk"},
        {id: "germany", name: "germany"},
        {id: "france", name: "france"},
        {id: "holand", name: "holand"},
        {id: "sweeden", name: "sweeden"},
      ],
      cava: [
        {id: "guarda_superior", name: "Guarda Superior"},
        {id: "joven", name: "joven"},
        {id: "reserva", name: "reserva"},
        {id: "gran_reserva", name: "gran_reserva"},
        {id: "paraje", name: "paraje"},
      ],
      produccion:
          [
            {id: "produccion_organica", name: "produccion_organica"},
            {id: "produccion_biodinamica", name: "produccion_biodinamica"},
            {id: "produccion_integral", name: "produccion_integral"},
          ],


      mins: ["00", "15", "30", "60"],
      hours: ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12",
        "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"],
    };

  },
  provide() {
    return {parentValidator: this.$validator}
  },
  computed: {
    fromDateDisp() {
      return this.fromDateVal;
      // format date, apply validations, etc. Example below.
      // return this.fromDateVal ? this.formatDate(this.fromDateVal) : "";
    },
    untilDateDisp() {
      return this.untilDateVal;
    }
  },
  methods: {
    addAddress() {
      this.evento.dirreccions.push(
          Object.assign({}, this.address)
      )
    },
    removeAddress(i) {
      this.evento.dirreccions.splice(i, 1);

    },
    addDate() {
      this.evento.fechas.push(
          Object.assign({}, this.datetemplate)
      )
    },
    removeDate(i) {
      this.evento.fechas.splice(i, 1);
    },

    submit() {

      this.$refs.observer.validate().then(success => {
        if (!success) {
          const el = document.querySelector(".v-messages.error--text:first-of-type");
          el.scrollIntoView(true);
          window.scrollBy(0, -150);
          return;
        }

        this.evento.nombre = this.evento.nombre_es+" "+this.evento.nombre_ca

        this.disabled = true
        if (this.evento.files.length > 0 && this.evento.files[0].hasOwnProperty("file_name") && !this.evento.files[0].file_name) {
          this.evento.files = []
        }
        const config = {
          method: this.mode,
          url: this.$store.state.endpoints.evento + this.id,
          headers: {Authorization: "Bearer " + this.$store.state.jwt},
          data: this.evento
        };
        this.$store.commit('showMessage', {
          "content": this.$t("Se esta guardando - por favor no cambies de página"),
          "color": "black"
        })
        axios(config)
            .then((response) => {
              this.$router.push('/eventos/admin');
              this.$store.commit('showMessage', {
                "content": this.$t("Actualizado con éxito"),
                "color": "green"
              })
            })
            .catch(error => {
              this.disabled = false
              console.log(error.response)
            });
      })
    },
    del() {
      const config = {
          method: "delete",
          url: this.$store.state.endpoints.evento + this.id,
          headers: {Authorization: "Bearer " + this.$store.state.jwt},
        };
      axios(config)
            .then((response) => {
              this.$router.push('/eventos/admin');
              this.$store.commit('showMessage', {
                "content": this.$t("Evento borrado"),
                "color": "red"
              })
            })
            .catch(error => {
              console.log(error)
            });

    },
    isarr(a) {
      if (typeof a === 'object') {
        return [a]
      } else {
        return a
      }
    }
  },
  mounted() {

  },
  created() {
    if (this.$route.params.id) {
      this.id = this.$route.params.id + "/"
      this.mode = "put"
      this.title = this.$i18n.t("Editar Evento");
      const config = {
        headers: {Authorization: "Bearer " + this.$store.state.jwt},
      };
      axios.get(this.$store.state.endpoints.evento + this.id, config)
          .then((response) => {
            this.evento = response.data
            if (typeof this.evento.permiso == "string") {
              this.evento.permiso = this.evento.permiso.replace("False", 'false')
              this.evento.permiso = this.evento.permiso.replace("True", 'true')
              this.evento.permiso = JSON5.parse(this.evento.permiso)
            }
            this.currentState = this.states[this.evento.state]
          })
          .catch(error => {
            console.log(error)
          });

    }
    else{
      this.currentState = this.states[0]
      this.evento.state=0
    }


  }
};
</script>






